import React, { useEffect, useState, useRef } from "react";

import { FileUploader } from "react-drag-drop-files";

import SignatureCanvas from "react-signature-canvas";

import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import NotificationPanels from "./NotificationPanels";
import TimeLeftTimer from "./TimeLeftTimer";
import Card from "./Card";
import NationalIDIcon from "../assets/img/national-id-icon.png";
import AddressIcon from "../assets/img/address-icon.png";
import EmploymentIcon from "../assets/img/employment-icon.png";
import EducationIcon from "../assets/img/education-icon.png";
import CheckIconGray from "../assets/img/check-icon-gray.png";
import RightSidebar from "./RightSidebar";
import "../assets/css/custom-modal.css";

import "../assets/css/dashboard.css";
import "../assets/css/inner-tabs-style2.css";
import UploadIcon from "../assets/img/upload-icon.svg";
import { getFaq } from "../Actions/FaqAction";

import { getData } from "../Actions/landingAction";
import { useDispatch, useSelector } from "react-redux";
import { differenceInTime } from "../Helper/common";

import { uploadFileViaMultipart } from "../Actions/personalDetailsActions";
import { saveAuth } from "../Actions/AuthorizationAction";
import { result } from "../Actions/userActions";
import CandidateTab from "./CandidateTab";
import Footer from "./Footer.js";

import Loader from "./Common/loader";
import { toast } from "react-toastify";
import ManualARNUpload from "./ManualARNUpload.jsx";

const Dashboard = () => {
  const [fileSize, setFileSize] = useState();
  const [authFlag, setAuthFlag] = useState(1);
  const [reference, setReference] = useState();
  const [drawSignatureWidth, setDrawSignatureWidth] = useState(400);
  const [showAuthCandidate, setShowAuthCandidate] = useState([]);
  //authorizationData.auth_flag
  // const [item, setItem] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(true); // Add modalOpen state
  const [showManualModal, setShowManualModal] = useState(true);

  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Update the body class when the modalOpen state changes
    // if (modalOpen) {
    //   document.body.classList.add("modal-open");
    // } else {
    //   document.body.classList.remove("modal-open");
    // }
  }, [modalOpen]);

  useEffect(() => {
    
    let list = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    // setItem(list);
    setAuthFlag(list.auth_complete);
    setReference(list.reference_number);

    var screenWidth = window.screen.width;
    if (screenWidth < 460) {
      setDrawSignatureWidth(220);
    }
  }, []);

  // console.log(reference);

  const typeSignature = useRef("");
  const typeSignatureBase64 = useRef("");

  const signatureDrawn = useRef(1);

  const signatureDrawCanvas = useRef("");

  const [signatureMode, setSignatureMode] = useState("");

  let sigPad = {};

  const [formError, setFormError] = useState({});

  const [data, setData] = useState([]);
  const [loadingPageData, setLoadingPageData] = useState([]);
  const [firstName, setfirstName] = useState();
  const [details, setDetails] = useState([]);
  const [personal, setPersonal] = useState("");
  const [isOnboarding, setIsOnboarding] = useState(0);

  const storeData = useSelector((state) => state.faq);
  const storeLandingData = useSelector((state) => state.landingPage);
  // console.log(storeData);
  const dispatch = useDispatch();
  //  console.log(storeData);

  const { faqData, loading, error } = storeData;
  const { Data, loadingData, errorData } = storeLandingData;
  
  useEffect(() => {
    if (typeof loadingData !== "undefined" && loadingData !== null) {
      if (loadingData === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        // reRenderAgain();
      }
    }
  }, [loadingData]);

  useEffect(() => {
    if (typeof faqData.data !== "undefined" && faqData.data !== null) {
      setData(faqData.data);
    }
  }, [faqData, storeData]);

  console.log(data);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getFaq());
    };

    fetchData();
  }, []);

  // set data for loadingPage
  useEffect(() => {
    if (typeof Data?.data !== "undefined" && Data?.data !== null) {
      
      if (Data.data.candidate_signature_config[0] == "3") {
        setSignatureMode("1");
      } else if (Data.data.candidate_signature_config[0] == "1") {
        // setSignatureMode("2");
        changeModeHandler(2);
      } else if (Data.data.candidate_signature_config.includes("2")) {
        setSignatureMode("3");
      }
      setShowAuthCandidate(Data.data.candidate_signature_config);
      
      setLoadingPageData(Data.data.candidate.candidate_login_expiry_date);
      setfirstName(Data.data.candidate.candidate_first_name);
      setDetails(Data.data.totalGroupsOfChecks);
      setPersonal(Data.data.personal_completed);
      setIsOnboarding(Data?.data?.show_onboarding_form);

      if(Data?.data?.authrize_complete == 1) {
        setAuthFlag(1);

        let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
        userLocalData.auth_complete = 1;
  
        localStorage.setItem("userVerificationCandidate", JSON.stringify(userLocalData));
      }

      localStorage.setItem("dob", Data?.data?.candidate_dob );
    }
  }, [Data, storeLandingData]);
  console.log("signature", signatureMode);

  //console.log(loadingPageData);

  const dateToExpiry = loadingPageData;
  const todayDate = Date.now();

  const [dayLeft, hourLeft, minuteLeft] = differenceInTime(
    todayDate,
    dateToExpiry
  );
  // console.log(minuteLeft);
  //console.log(new Date(dateToExpiry));

  useEffect(() => {
    const pageData = async () => {
      dispatch(getData());
    };

    pageData();
  }, []);

  //   const [typeSignatureClicked, setTypeSignatureClicked] = useState(0);

  //   useEffect(() => {

  //     console.log("s");

  //     const typedName = typeSignature.current.value;

  //     var c = document.getElementById("myCanvas");
  //     var ctx = c.getContext("2d");

  //     ctx.font = "30px Comic Sans MS";
  //     ctx.fillStyle = "red";
  //     ctx.textAlign = "center";
  //     ctx.fillText(typedName, c.width/2, c.height/2);

  //    // const base64Canvas = c.toDataURL("image/jpeg");

  // var pngUrl = c.toDataURL(); // PNG is the default

  //     console.log(pngUrl);

  //     setTypeSignatureClicked(0);
  //   }, [typeSignatureClicked]);

  const typeSignatureHandler = (e) => {
    const textLength = e.target.value.length;
    console.log(textLength);
    const typedName = typeSignature.current.value;
    var c = document.getElementById("myCanvas");

    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    if (textLength <= 15) {
      ctx.font = "36px Comic Sans MS";
    } else if (textLength > 15 && textLength <= 25) {
      ctx.font = "30px Comic Sans MS";
    } else {
      ctx.font = "20px Comic Sans MS";
    }
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.fillText(typedName, c.width / 2, c.height / 2);

    // const base64Canvas = c.toDataURL("image/jpeg");

    var pngUrl = c.toDataURL(); // PNG is the default

    typeSignatureBase64.current.value = pngUrl;

    // console.log(pngUrl);
  };

  const changeModeHandler = (mode) => {
    // console.log(mode);
    setSignatureMode(mode);
  };

  const formValidation = (formValues) => {
    const errors = {};

    // console.log(formValues);

    if (formValues.mode == "1") {
      const typeSignatureValue = typeSignature.current.value;

      if (typeSignatureValue === "") {
        alert("Please enter name");
        errors.mode1 = "This field is required.";
      }
      if (!/^[a-zA-Z\s]*$/.test(typeSignatureValue)) {
        alert("Name must be albhabets (A-Z/a-z)");
        errors.mode1 = "Name must be albhabets (A-Z/a-z)";
      }

      //errors.mode = "This field is required.";
      //email.current.style.border = "1px solid red";
    } else {
      //email.current.style.border = "1px solid #E1E4EB";
    }

    if (formValues.mode == "2") {
      let signpadEmpty = sigPad.isEmpty();
      if (signpadEmpty) {
        alert("Please Draw Signature");
        errors.mode2 = "This field is required.";
      }

      //errors.mode = "This field is required.";
      //email.current.style.border = "1px solid red";
    } else {
      //email.current.style.border = "1px solid #E1E4EB";
    }

    if (formValues.mode == "3") {
      if (fileUpLoaded === null) {
        alert("Please upload file");
        errors.mode3 = "This field is required.";
      }

      //errors.mode = "This field is required.";
      //email.current.style.border = "1px solid red";
    } else {
      //email.current.style.border = "1px solid #E1E4EB";
    }

    return errors;
  };

  const signatureSubmitHandler = (event) => {
    event.preventDefault();

    const formData = {};
    formData.mode = parseInt(signatureMode);

    const err = formValidation(formData);

    const isValidationPassed = Object.keys(err).length === 0;

    if (!isValidationPassed) {
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      if (formData.mode == 1) {
        formData.typedSignature = typeSignatureBase64.current.value;
      } else if (formData.mode == 2) {
        formData.drawSignature = sigPad
          .getTrimmedCanvas()
          .toDataURL("image/png");
      }

      // console.log(sigPad.getTrimmedCanvas().toDataURL('image/png'));
      // console.log(sigPad.isEmpty());
      if (fileSize > 5242880 && formData.mode == 3) {
      } else {
        dispatch(saveAuth(formData));
      }
      // Close the modal when submitting
      setModalOpen(false);
    }
  };

  const authStoreData = useSelector((state) => state.authorization);
  const {
    authorizationData,
    loading: authLoad,
    error: authErr,
  } = authStoreData;

  useEffect(() => {
    if (
      typeof authorizationData.auth_flag !== "undefined" &&
      authorizationData.auth_flag !== null
    ) {
      // console.log(authorizationData.auth_flag);
      setAuthFlag(authorizationData.auth_flag);

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      userLocalData.auth_complete = authorizationData.auth_flag;

      console.log(userLocalData);

      localStorage.setItem("userVerificationCandidate", JSON.stringify(userLocalData));
      // setLastPage(hiringData.data.PaginationMetaDataVal.LastPage);
      // setTotalResult(hiringData.data.PaginationMetaDataVal.TotalResult);
    }
  }, [authStoreData, authorizationData]);

  //setting loader while saving

  useEffect(() => {
    if (typeof authLoad !== "undefined" && authLoad !== null) {
      if (authLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        // reRenderAgain();
      }
    }
  }, [authLoad]);

  const fileTypes = ["JPG", "PNG", "JPEG"];

  const [fileUpLoaded, setFileUpLoaded] = useState(null);
  const handleChange = (file) => {
    //alert("x")

    setFileSize(file.size);
    setFileUpLoaded(file);
    console.log(JSON.stringify(file));
    if (file.size < 5242880) {
      dispatch(uploadFileViaMultipart("uploadedSignature", file));
    }
  };

  //console.log(fileUpLoaded.name);

  // const selectChange = (file) => {
  // };

  const showError=(name, link, e)=>{
    if((name == "Onboarding Details" || name == "Declaration Details" ) && link == 0){
      e.preventDefault();
      let msg;
      if(name == "Onboarding Details"){
        msg = "Please save the previous forms to enable Onboarding form.";
      }else{
        msg = "Please save the previous forms to enable Declaration form.";
      }
      toast.dismiss();
      toast.error(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }


  const personalDetailsIcon = {
    nid: "fa-solid fa-shield-halved",
    address: "fas fa-map-location-dot",
    education: "fas fa-book",
    employment: "fas fa-briefcase",
    professional: "fas fa-thumbs-up",
    personal: "fas fa-user",
    id: "fas fa-list",
    credit: "fas fa-landmark",
    other: "fas fa-rectangle-list",
    license: "fas fa-file-contract",
    pv: "fas fa-user-shield",
    eligiblity: "fas fa-clipboard-check",
    drug: "fas fa-vial-circle-check",
    doctor: "fas fa-staff-snake",
    shield: "fas fa-user-shield",
    eadhar: "fas fa-address-card",
    work: "fas fa-clipboard-check",
    dav: "fa-solid fa-location-dot",
    bank: "icon fas fa-university",
    visualDoc: "icon fas fa-rectangle-list",
  };

  function clearSignature() {
    sigPad.clear();
  }
  let Complete = 0;
  console.log(Complete);
  //console.log(item.auth_complete);
  return (
    <>
      {isLoading && <Loader />}
      <NotificationPanels />
      <Header firstName={firstName} />
      <Sidebar />
      <section className="h-100 main-section">
        <div className="container-fluid h-100">
          <div className="row h-100">
            <div className="col-md-8">
              <h4 className="fnt-smi-bld">Welcome, {firstName}</h4>

              <TimeLeftTimer
                day={dayLeft}
                hour={hourLeft}
                minute={minuteLeft}
              />
              <div className="clearfix"></div>

              <div className="row mt-3">
                <div className="col-md-12">
                  <Link
                    to={`${ isOnboarding == 1 ? `/case-initiation/check-detail/${reference}/11` : `/case-initiation/check-detail/${reference}/profile`}`}
                  >
                    <button className="btn btn-primary btn-lg">
                      Click here to start
                    </button>
                  </Link>
                </div>
              </div>

              <div className="row mt-4 dashboard-cards">
                <div className="col-md-4">
                  <Link
                    to={`${ isOnboarding == 1 ? "" :  `/case-initiation/check-detail/${reference}/profile`}`}
                    className="no-effect-link"
                  >
                    <Card
                      icon={personalDetailsIcon.personal}
                      cardStatus={personal}
                      status={
                        isOnboarding == 1 ?
                        "#F3F4F6" :
                        personal == "0"
                          ? "#363F72"
                          : personal == "1"
                          ? "green"
                          : "blue"
                      }
                      cardHeading="Personal Details"
                      cardText={"No Document requried"}
                      //       cardText="Name, email, phone no. and  adrress etc."
                      isDisabled={isOnboarding}
                    />
                  </Link>
                </div>

                {Object.entries(details).map((value, index) => {
                  let cardClass = "";
                  let onboardingLink=1;
                  if (value[1].group_id == "2") {
                    cardClass = personalDetailsIcon.address;
                  } else if (value[1].group_id == "3") {
                    cardClass = personalDetailsIcon.education;
                  } else if (value[1].group_id == "10") {
                    cardClass = personalDetailsIcon.drug;
                  } else if (value[1].group_id == "4") {
                    cardClass = personalDetailsIcon.employment;
                  } else if (value[1].group_id == "5") {
                    cardClass = personalDetailsIcon.professional;
                  } else if (value[1].group_id == "6") {
                    cardClass = personalDetailsIcon.professional;
                  } else if (value[1].group_id == "7") {
                    cardClass = personalDetailsIcon.shield;
                  } else if (value[1].group_id == "8") {
                    cardClass = personalDetailsIcon.credit;
                  } else if (value[1].group_id == "9") {
                    cardClass = personalDetailsIcon.other;
                  } else if (value[1].group_id == "12") {
                    cardClass = personalDetailsIcon.license;
                  } else if (value[1].group_id == "13") {
                    cardClass = personalDetailsIcon.doctor;
                  } else if (value[1].group_id == "nid") {
                    cardClass = personalDetailsIcon.nid;
                  } else if (value[1].group_id == "eaadhar") {
                    cardClass = personalDetailsIcon.eadhar;
                  } else if (value[1].group_id == "14") {
                    cardClass = personalDetailsIcon.work;
                  } else if (value[1].group_id == "15") {
                    cardClass = personalDetailsIcon.shield;
                  } else if (value[1].group_id == "18") {
                    cardClass = personalDetailsIcon.address;
                  } else if (value[1].group_id == "30") {
                    cardClass = personalDetailsIcon.dav;
                  } else if (value[1].group_id == "20") {
                    cardClass = personalDetailsIcon.bank;
                  } else if (value[1].group_id == "21") {
                    cardClass = personalDetailsIcon.visualDoc;
                  } else if (value[1].group_id == "22") {
                    cardClass = personalDetailsIcon.employment;
                  }else if(value[1].group_id == "23"){
                    cardClass = personalDetailsIcon.employment;
                  } else if (value[1].group_id == 50 || value[1].name == "Declaration Details") {
                    cardClass = personalDetailsIcon.visualDoc;
                    for(let i=0; i<Data?.data?.totalGroupsOfChecks.length-1;i++){
                      if(Data?.data?.totalGroupsOfChecks[i].name != "Declaration Details" && Data?.data?.totalGroupsOfChecks[i].completed == 0){
                        onboardingLink =0;
                      }
                    }
                  } else if (value[1].name == "Onboarding Details"){
                    for(let i=0; i<Data?.data?.totalGroupsOfChecks.length-1;i++){
                      if(Data?.data?.totalGroupsOfChecks[i].name != "Onboarding Details" && Data?.data?.totalGroupsOfChecks[i].completed == 0){
                        onboardingLink =0;
                      }
                    }
                    cardClass = personalDetailsIcon.personal
                  } else if (value[1].completed == "1") {
                    Complete = Complete + 1;
                  }
                  let link = `/case-initiation/check-detail/${reference}/${value[1].group_id}`;
                  
                  if (value[1].name == "Onboarding Details" || value[1].name == "Declaration Details"){
                    for(let i=0; i<Data?.data?.totalGroupsOfChecks.length-1;i++){
                      if(Data?.data?.totalGroupsOfChecks[i].name != "Onboarding Details" && Data?.data?.totalGroupsOfChecks[i].completed == 0){
                        onboardingLink = 0;
                        // link = '#'
                      }
                  }
                }

                  // if(value[1].name == "Onboarding Details"){
                  //   link = `/onbordingDetailsInstaform/`
                  // } value[1].name == "Onboarding Details" && onboardingLink == 0 ? "#":
                  console.log("link", link, onboardingLink);
                  return (
                    <div className="col-md-4">
                      <Link to={( value[1].name == "Onboarding Details" || value[1].name == "Declaration Details") && onboardingLink == 0 ? "#" : (isOnboarding == 1 && value[1].name != "Onboarding Details" || personal != "1") ? "#" : link}  onClick={(e)=>showError(value[1].name, onboardingLink, e)} className="no-effect-link">
                        <Card
                          icon={cardClass}
                          cardStatus={value[1].completed}
                          status={
                            isOnboarding == 1 && value[1].name != "Onboarding Details" ?
                            "#F3F4F6" :
                            value[1].completed == "0"
                              ? "white"
                              : value[1].completed == "1"
                              ? "green"
                              : "blue"
                          }
                          cardHeading={value[1].name}
                          cardText={
                            value[1].msg != ""
                              ?  value[1].msg !== "No Document Required" ? "Documents Required - " + value[1].msg
                              : "No Document requried" : "No Document requried"
                          }
                          isOnboarding={isOnboarding}
                          isDisabled={value[1].is_disabled || personal != "1"}
                        />
                      </Link>
                    </div>
                  );
                })}
                {console.log(Complete)}
                {/*<div className="col-md-4">
                    <Card
                      cardImage={PersonalDetailsIcon}
                      cardHeading="agvdh"
                      cardText="Name, email, phone no. and  adrress etc."
                    />
                  </div> 
                 <div className="col-md-4">
                    <Card
                      cardImage={PersonalDetailsIcon}
                      cardHeading="personal"
                      cardText="Name, email, phone no. and  adrress etc."
                    />
                  </div> 
               
              {/* <div className="col-md-4">
                  <Card
                    cardImage={NationalIDIcon}
                    cardHeading={details[3].name} 
                    cardText="Adhaar Card, Pan card, Voter IDs etc."
                  />
                </div>
                <div className="col-md-4">
                  <Card
                    cardImage={AddressIcon}
                    cardHeading={details[5].name} 
                    cardText="Adhaar Card, Pan card, Voter IDs etc."
                  />
                </div>
                <div className="col-md-4">
                  <Card
                    cardImage={EmploymentIcon}
                    cardHeading={details[7].name} 
                    cardText="Adhaar Card, Pan card, Voter IDs etc."
                  />
                </div>
                <div className="col-md-4">
                  <Card
                    cardImage={EducationIcon}
                    cardHeading={details[9].name} 
                    cardText="Adhaar Card, Pan card, Voter IDs etc."
                  />
                  </div>
                  <div className="col-md-4">
                  <Card
                    cardImage={EducationIcon}
                    cardHeading={details[10].name} 
                    cardText="Adhaar Card, Pan card, Voter IDs etc."
                  />
                  </div>  */}
              </div>
              {/* <div className="row mt-3">
                <div className="col-md-12">
                  <h5 className="fnt-smi-bld mb-0">Documents needed</h5>
                  <p className="text-muted fnt-sml-md">
                    Please keep following document handy
                  </p>
                  <div className="d-flex align-items-center mb-3">
                    <img src={CheckIconGray} alt="" className="mr-2" />
                    <span style={{ color: "#475467" }}>
                      National IDs: (Any 1 document ) Adhaar Card ,Voter ID,
                      Passport, License{" "}
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <img src={CheckIconGray} alt="" className="mr-2" />
                    <span style={{ color: "#475467" }}>
                      Education : All year marksheets, degrees, certificate{" "}
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <img src={CheckIconGray} alt="" className="mr-2" />
                    <span style={{ color: "#475467" }}>
                      Employment: 3 months salary slip, Offer letter, reliving
                      letter{" "}
                    </span>
                  </div>
                  {/* <div className="d-flex align-items-center mb-3">
                    <img src={CheckIconGray} alt="" className="mr-2" />
                    <span style={{ color: "#475467" }}>
                      GST & PAN: Pan card, GST certificate{" "}
                    </span>
                  </div> 
                  <div className="d-flex align-items-center mb-3">
                    <img src={CheckIconGray} alt="" className="mr-2" />
                    <span style={{ color: "#475467" }}>
                      Address ( Any 1 document) : Electricity bill, Phone bill,
                      Ration card{" "}
                    </span>
                  </div>
                </div>
              </div> */}
              <div class="copyright hide-on-mbl">
                <Footer />
              </div>
            </div>
            <div className="col-md-4">
              <RightSidebar data={data} />
              <div class="copyright show-on-mbl">
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </section>
      {authFlag === 0 && Data?.data?.is_candidate_arn_upload_enabled 
      ? <>
      {/* {Removing previous normal modal of ARN code implementation issue} */}
      {modalOpen && setModalOpen(false)} 
      <ManualARNUpload showManualModal = {showManualModal} setShowManualModal = {setShowManualModal}/>
      </> 
      : authFlag === 0 && (
      <div
        className={`dashboard custom-modal-dialog ${modalOpen ? "show" : ""}`}
        id="authorizeBgvPopup"
      >
        {" "}
        <div className="modal-wrapper authorization-modal">
          <div
            className="modal-content p-4"
            id="authorization-modal"
            style={{ overflow: "unset" }}
          >
            <h3 className="fnt-smi-bld mb-3 auth-header">
              Authorize background verification
            </h3>{" "}
            <div className="text-wrapper-modal">
              <p className="text-muted">
                Please note that AuthBridge will be conducting your employment
                background verification on behalf of your employer. Given below
                is the Authorization letter, where you need to sign to authorize
                for your background verification. You have right to deny and not
                sign the Authorization letter if you do not want to allow for
                verification. You are also required to go through our 
                <a href="https://ibridge.authbridge.com/home/privacy-policy/" target="_">
                {/* href="https://goibridge.authbridge.com/privacy-policy/" */}
                    {" "}
                    Privacy policy
                  </a>
                {/* Privacy
                Policy. */}
              </p>
              <p className="text-muted">
                The employment verification report may include information
                regarding my character, reputation, personal characteristics,
                National Identity Verification, Education details, Employment
                history, References from professional and personal associates,
                Credit history, Court records (including criminal verification)
                as permitted by law, Health Check-up, Drug Test, Address
                Verification, and any other check as found relevant for the
                profile.
              </p>
              {Data?.data?.clientId	== 108942 && 
              <div className="text-muted mb-2">
                <div className="fnt-smi-bld">
                “Privacy Notice: <br />
                </div>
                Nagarro acts as the data fiduciary and engages appointed vendors to conduct background verification checks. By signing this authorization letter, you agree and acknowledge that your personal data will be collected, processed, and stored in compliance with applicable data protection laws. Detailed information about how your personal data is handled can be found at: 
                <a href="https://www.nagarro.com/hubfs/NagarroWebsiteRedesign-Aug2020/Assets/Docs/Applicant%20Privacy%20Notice-EN.pdf" target="_">
                  {" "}
                Applicant Privacy Notice-EN.pdf  “
                </a>
              </div>
              }
              </div>
              <ul
                className="nav nav-tabs inner-tabs-style2 mt-3"
                id="myTab"
                role="tablist"
              >
                {showAuthCandidate && showAuthCandidate.map((val,ind)=>{
                  if(val == "1"){
                  return<>
                  {" "}
                <li className="nav-item d-flex justify-content-center align-items-center">
                  {" "}
                  <a
                    className={`nav-link2 ${signatureMode == 2 ? ' active' : ''}`}
                    id="drawSignature-tab"
                    data-toggle="tab"
                    href="#drawSignature"
                    role="tab"
                    aria-controls="drawSignature"
                    aria-selected="false"
                    onClick={() => changeModeHandler(2)}
                    style={{marginLeft:"-28px"}}
                  >
                    Draw Signature
                  </a>{" "}
                </li>
                  </>
                  }
                  if (val == "2") {
                    return (
                      <>
                        {" "}
                        <li className="nav-item d-flex justify-content-center align-items-center">
                          {" "}
                          <a
                            className={`nav-link2 ${
                              signatureMode == 3 ? " active" : ""
                            }`}
                            id="uploadSignature-tab"
                            data-toggle="tab"
                            href="#uploadSignature"
                            role="tab"
                            aria-controls="uploadSignature"
                            aria-selected="false"
                            onClick={() => changeModeHandler(3)}
                          >
                            Upload Signature
                          </a>{" "}
                        </li>
                      </>
                    );
                  }
                  if(val == "3"){
                    return<>
                   {" "}
                <li className="nav-item d-flex justify-content-center align-items-center">
                  {" "}
                  <a
                    className={`nav-link2 ${signatureMode == 1 ? ' active' : ''}`}
                    id="typeSignature-tab"
                    data-toggle="tab"
                    href="#typeSignature"
                    role="tab"
                    aria-controls="typeSignature"
                    aria-selected="true"
                    onClick={() => changeModeHandler(1)}
                    style={{marginRight:"-33px;"}}
                  >
                    Type Signature{" "}
                  </a>{" "}
                </li>
                    </>
                  }
                })}
              {/* {" "}
                <li className="nav-item d-flex justify-content-center align-items-center">
                  {" "}
                  <a
                    className="nav-link active"
                    id="typeSignature-tab"
                    data-toggle="tab"
                    href="#typeSignature"
                    role="tab"
                    aria-controls="typeSignature"
                    aria-selected="true"
                    onClick={() => changeModeHandler(1)}
                  >
                    Type Signature{" "}
                  </a>{" "}
                </li>{" "}
                <li className="nav-item d-flex justify-content-center align-items-center">
                  {" "}
                  <a
                    className="nav-link2"
                    id="drawSignature-tab"
                    data-toggle="tab"
                    href="#drawSignature"
                    role="tab"
                    aria-controls="drawSignature"
                    aria-selected="false"
                    onClick={() => changeModeHandler(2)}
                  >
                    Draw Signature
                  </a>{" "}
                </li>{" "}
                <li className="nav-item d-flex justify-content-center align-items-center">
                  {" "}
                  <a
                    className="nav-link2"
                    id="uploadSignature-tab"
                    data-toggle="tab"
                    href="#uploadSignature"
                    role="tab"
                    aria-controls="uploadSignature"
                    aria-selected="false"
                    onClick={() => changeModeHandler(3)}
                  >
                    Upload Signature
                  </a>{" "}
                </li>{" "} */}
              </ul>{" "}
              <div className="tab-content safari_only p-3" id="myTabContent">
                <div
                  // className="tab-pane fade"
                  className={`tab-pane fade ${signatureMode == 1 ? 'show active' : ''}`}
                  id="typeSignature"
                  role="tabpanel"
                  aria-labelledby="typeSignature-tab"
                >
                  {" "}
                  <div className="form-group">
                    {" "}

                    <label>Your Name</label>{" "}
                    <input
                      type="text"
                      className="form-control"
                      maxLength="35"
                      name="typeSignature"
                      ref={typeSignature}
                      onChange={typeSignatureHandler}
                    />{" "}
                  </div>
                  <div className="text-center">
                    <canvas
                      id="myCanvas"
                      height="200"
                      width="1000"
                      className="common-white-box w-100"
                      style={{ border: "1px solid #d3d3d3" }}
                    >
                      {" "}
                      Your browser does not support the HTML canvas tag.{" "}
                    </canvas>
                  </div>
                  <input
                    type="hidden"
                    name="typeSignatureBase64"
                    ref={typeSignatureBase64}
                  />
                  {/* <div className="form-group"> <textarea name="" id="" rows="5" className="form-control"></textarea> </div> */}
                  <div className="text-right">
                    {" "}
                    <small className="text-muted">
                      Date: {new Date().getDate()}/{new Date().getMonth() + 1}/
                      {new Date().getFullYear()}{" "}
                    </small>{" "}
                  </div>{" "}
                </div>
                <div
                  // className="tab-pane fade  show active"
                  className={`tab-pane fade ${signatureMode == 2 ? 'show active' : ''}`}

                  id="drawSignature"
                  role="tabpanel"
                  aria-labelledby="drawSignature-tab"
                >
                  <div className="text-center draw-signature-wrapper">
                    <SignatureCanvas
                      ref={(ref) => {
                        sigPad = ref;
                      }}
                      //  ref={sigPad}
                      penColor="black"
                      backgroundColor="rgba(225,225,225, 0.4)"
                      canvasProps={{
                        width: drawSignatureWidth,
                        height: 180,
                        className: "sigCanvas",
                      }}
                    />
                  </div>
                  <input
                    type="hidden"
                    name="signatureDrawn"
                    ref={signatureDrawn}
                    value="0"
                  />
                  <center>
                    <button className="btn-secondary clear-btn" onClick={clearSignature}>
                      Clear
                    </button>
                  </center>
                  {/* <div className="common-white-box draw-signature-box mb-3">
</div> */}{" "}
                  <div className="text-right">
                    {" "}
                    <small className="text-muted">
                      Date: {new Date().getDate()}/{new Date().getMonth() + 1}/
                      {new Date().getFullYear()}
                    </small>{" "}
                  </div>{" "}
                </div>
                <div
                  // className="tab-pane fade"
                  className={`tab-pane fade ${signatureMode == 3 ? 'show active' : ''}`}

                  id="uploadSignature"
                  role="tabpanel"
                  aria-labelledby="uploadSignature-tab"
                >
                  {" "}
                  <div
                    className="common-white-box d-flex align-items-center justify-content-center flex-column kih-drap-drop"
                    style={{ minHeight: "180px" }}
                  >
                    {" "}
                    <img src={UploadIcon} alt="" className="mb-2" />{" "}
                    <div className="text-center pl-2 pr-2">
                      {" "}
                      <FileUploader
                        handleChange={handleChange}
                        name="file"
                        maxSize="5"
                        onSizeError={(file) => {
                          alert("file size larger than 5 mb");
                        }}
                        types={fileTypes}
                      />
                      {/* <a href="#">Click to upload</a>{" "}
                <span className="text-muted">or drag and drop</span> */}
                    <br />{" "}
                    {fileUpLoaded != null ? <h6>{fileUpLoaded.name}</h6> : ""}
                    <span className="text-muted">
                      PNG, JPG, JPEG (max. 5Mb)
                    </span>{" "}
                  </div>{" "}
                </div>
                <div className="text-right mt-3">
                  {" "}
                  <small className="text-muted">
                    Date: {new Date().getDate()}/{new Date().getMonth() + 1}/
                    {new Date().getFullYear()}
                  </small>{" "}
                </div>{" "}
              </div>{" "}
            </div>
            <center className="mt-4">
              {" "}
              <input
                type="hidden"
                name="signatureMode"
                value={signatureMode}
              />{" "}
              <button
                className="btn btn-primary btn-lg"
                onClick={signatureSubmitHandler}
              >
                Accept &amp; Continue
              </button>{" "}
            </center>
          </div>
        </div>
      </div>
       )}
    </>
  );
};
export default Dashboard;